import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { Button } from '../../globalStyles';
import {
  Nav,
  NavbarContainer,
  NavLogo,
  NavIcon,
  MobileIcon,
  NavMenu,
  NavItem,
  NavItemBtn,
  NavLinks,
  NavBtnLink
} from './Navbar.elements';
import { animateScroll } from 'react-scroll'
function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  const backToTopAndCloseMobileMenu = () => {
    animateScroll.scrollToTop()
    closeMobileMenu()
  };

  window.addEventListener('resize', showButton);

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav>
          <NavbarContainer>
            <NavLogo to='/' onClick={closeMobileMenu}>
              <NavIcon />
              GroundWire
            </NavLogo>
            <MobileIcon onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </MobileIcon>
            <NavMenu onClick={handleClick} click={click}>
              <NavItem>
                <NavLinks to='our-home' onClick={backToTopAndCloseMobileMenu}>
                  INICIO
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='our-functionality' smooth={true} duration={1000} onClick={closeMobileMenu}>
                  ¿CÓMO FUNCIONA?
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='our-clients' smooth={true} duration={1000} onClick={closeMobileMenu}>
                  CLIENTES
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='our-services' smooth={true} duration={1000} onClick={closeMobileMenu}>
                  SERVICIOS
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='our-security' smooth={true} duration={1000} onClick={closeMobileMenu}>
                  NOSOTROS
                </NavLinks>
              </NavItem>
              <NavItemBtn>
                {button ? (
                  <NavBtnLink to='our-estimations' smooth={true} duration={1000}>
                    <Button primary>ESTIMAR MI PROYECTO</Button>
                  </NavBtnLink>
                ) : (
                    <NavBtnLink to='our-estimations' smooth={true} duration={1000}>
                      <Button onClick={closeMobileMenu} fontBig primary>
                        ESTIMAR MI PROYECTO
                    </Button>
                    </NavBtnLink>
                  )}
              </NavItemBtn>
            </NavMenu>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
